export default class seasonalEventSettings {
    title!: string;
    icon!: string;
    iconPrimaryColor!:string;
    iconSecondaryColor !: string;
    headerBackgroundColor !: string;
}